import { ArgumentError } from "../errors";


export namespace ObjectEquality
{
    export function areEqual<T>(first: T, second: T): boolean
    {
        const comparer = new ObjectComparer();
        return comparer.areEqual(first, second);
    }


    class ObjectComparer
    {
        constructor()
        {
        }

        areEqual<T>(first: T, second: T): boolean;
        areEqual(first: any, second: any): boolean
        {
            if (first === second)
                return true;

            if (!first || !second)
                return false;

            if (typeof first !== 'object' || typeof second !== 'object')
                return false;

            if (first instanceof Date && second instanceof Date)
                return first.valueOf() === second.valueOf();

            const arrays = Array.isArray(first) && Array.isArray(second);
            if (!arrays)
            {
                if (Array.isArray(first) || Array.isArray(second))
                    return false;
            }

            if (this.seen.has(first) || this.seen.has(second))
                throw new ArgumentError(`Unable to compare circular structures.`);
            this.seen.add(first);
            this.seen.add(second);

            return (
                (arrays) ?
                    this.compareList(first, second) :
                    this.compareRecord(first, second)
            );
        }

        private compareRecord(first: Record<string, any>, second: Record<string, any>): boolean
        {
            const firstKeys = Object.keys(first);
            const secondKeys = Object.keys(second);

            if (firstKeys.length !== secondKeys.length)
                return false;

            for (const key of firstKeys)
            {
                if (!second.hasOwnProperty(key))
                    return false;

                const areEqual = this.areEqual(first[key], second[key]);
                if (!areEqual)
                    return false;
            }

            return true;
        }

        private compareList<T>(first: T[], second: T[]): boolean
        {
            if (first.length !== second.length)
                return false;

            for (let i = 0; i < first.length; i++)
            {
                const areEqual = this.areEqual(first, second);
                if (!areEqual)
                    return false;
            }

            return true;
        }


        private seen = new Set();
    }
}
